/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DevicesInputs */

const th_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`อุปกรณ์`)
};

const en_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devices`)
};

const ja_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`端末`)
};

const zh_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设备`)
};

const es_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivos`)
};

const pt_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivos`)
};

const id_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perangkat`)
};

const fr_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appareils`)
};

const tl_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga device`)
};

const vi_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thiết bị`)
};

const ko_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기기`)
};

const de_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geräte`)
};

const ru_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Устройства`)
};

const tr_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cihazlar`)
};

const it_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dispositivi`)
};

const pl_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urządzenia`)
};

const uk_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пристрої`)
};

const hi_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपकरण`)
};

const ar_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الأجهزة`)
};

const ms_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peranti`)
};

const bn_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`যন্ত্র`)
};

const zh_tw2_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`裝置`)
};

const zh_hk2_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`裝置`)
};

const ur_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آلات`)
};

const fa_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دستگاه‌ها`)
};

const sw_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vifaa`)
};

const nl_devices = /** @type {(inputs: DevicesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apparaten`)
};

/**
* | output |
* | --- |
* | "Devices" |
*
* @param {DevicesInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const devices = /** @type {((inputs?: DevicesInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DevicesInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_devices(inputs)
	if (locale === "ja") return ja_devices(inputs)
	if (locale === "zh") return zh_devices(inputs)
	if (locale === "es") return es_devices(inputs)
	if (locale === "pt") return pt_devices(inputs)
	if (locale === "id") return id_devices(inputs)
	if (locale === "fr") return fr_devices(inputs)
	if (locale === "tl") return tl_devices(inputs)
	if (locale === "vi") return vi_devices(inputs)
	if (locale === "ko") return ko_devices(inputs)
	if (locale === "de") return de_devices(inputs)
	if (locale === "ru") return ru_devices(inputs)
	if (locale === "tr") return tr_devices(inputs)
	if (locale === "it") return it_devices(inputs)
	if (locale === "pl") return pl_devices(inputs)
	if (locale === "uk") return uk_devices(inputs)
	if (locale === "hi") return hi_devices(inputs)
	if (locale === "ar") return ar_devices(inputs)
	if (locale === "ms") return ms_devices(inputs)
	if (locale === "bn") return bn_devices(inputs)
	if (locale === "zh-TW") return zh_tw2_devices(inputs)
	if (locale === "zh-HK") return zh_hk2_devices(inputs)
	if (locale === "ur") return ur_devices(inputs)
	if (locale === "fa") return fa_devices(inputs)
	if (locale === "sw") return sw_devices(inputs)
	if (locale === "nl") return nl_devices(inputs)
	return en_devices(inputs)
});